import React, { useEffect, useState, useMemo } from "react";

import {
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
  CardBody,
} from "reactstrap";
import classnames from "classnames";

import { toast } from "react-toastify";

// RangeSlider
import "nouislider/distribute/nouislider.css";
import DeleteModal from "../../Components/Common/DeleteModal";

import BreadCrumb from "../../Components/Common/BreadCrumb";
import TableContainer from "./TableContainer";
import RestrictedChannels from "../../Components/Common/RestrictedChannels";

//Import actions
import {
  getProducts as onGetProducts,
  deleteProducts,
  getProductById as onGetProductById,
  getHotProducts as onGetHotProducts,
} from "../../slices/thunks";

// import Select from "react-select";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import Loader from "../../Components/Common/Loader";
import ProductDetail from "./ProductDetail";
import imageEmpty from "../../assets/images/new.png";
import SalesChannels from "../../Components/Common/SalesChannels";
import DebouncedInput from "../../Components/Common/DebouncedInput";
import moment from "moment";

const Products = (props) => {
  const dispatch = useDispatch();
  const [firstLoad, setFirstLoad] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const [detailsModal, setDetailsModal] = useState(false);
  const selectProductData = createSelector(
    (state) => state.Products,
    (products) => products.products,
    (pagination) => pagination,
    (loading) => loading
  );
  // Inside your component
  const { product, products, hotProducts, pagination, paginationHot, loading } =
    useSelector(selectProductData);

  const [productList, setProductList] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [selectedMulti, setselectedMulti] = useState(null);
  const [productSelected, setProductSelected] = useState(null);
  //const [product, setProduct] = useState(null);

  const [searchText, setSearchText] = useState(null);

  function handleMulti(selectedMulti) {
    setselectedMulti(selectedMulti);
  }

  useEffect(() => {
    if (products && hotProducts) {
      if (activeTab != "6") {
        setProductList(products);
      } else {
        setProductList(hotProducts);
      }
      setFirstLoad(false);
    }
  }, [products, hotProducts]);

  /*
  useEffect(() => {
    if (products) {
      setFirstLoad(false);
      setProductList(products);
    }
  }, [dispatch, products]);
*/
  useEffect(() => {
    !firstLoad && getProducts();
  }, [searchText]);

  /*
  useEffect(() => {
    if (!isEmpty(products)) setProductList(products);
  }, [products]);
*/

  const getProductsAndHot = () => {};

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      if (tab === "6") {
        const data = {
          page: 0,
          total_rows: pagination ? pagination?.pageSize : 50,
          searchText: searchText,
        };
        dispatch(onGetHotProducts(data));
      } else {
        const data = {
          page: 0,
          total_rows: pagination ? pagination?.pageSize : 50,
          searchText: searchText,
          status: null,
          inStock: null,
          outStocK: null,
        };
        switch (type) {
          case "all":
            data.status = null;
            break;
          case "Active":
            data.status = 0;
            break;
          case "Inactive":
            data.status = 1;
            break;
          case "In Stock":
            data.inStock = true;
            break;
          case "Out of Stock":
            data.outStocK = true;
            break;
          case "Hidden":
            data.visible = false;
            break;
        }
        dispatch(onGetProducts(data));
      }
    }
  };

  const [cate, setCate] = useState("all");

  const categories = (category) => {
    let filteredProducts = products;
    if (category !== "all") {
      filteredProducts = products.filter(
        (product) => product.category === category
      );
    }
    setProductList(filteredProducts);
    setCate(category);
  };

  const getProducts = (page, pageSize) => {
    const data = {
      page: page ? page : 0,
      total_rows: pageSize ? pageSize : pagination ? pagination?.pageSize : 50,
      searchText: searchText,
      status: null,
      inStock: null,
      outStocK: null,
    };

    switch (Number(activeTab)) {
      case 2:
        data.status = 0;
        break;
      case 3:
        data.status = 1;
        break;
      case 4:
        data.inStock = true;
        break;
      case 5:
        data.outStocK = true;
        break;
      case 7:
        data.visible = false;
        break;
    }
    dispatch(onGetProducts(data));
    dispatch(onGetHotProducts(data));
  };

  const onUpdate = (value) => {
    setProductList(
      productList.filter(
        (product) => product.price >= value[0] && product.price <= value[1],
        (document.getElementById("minCost").value = value[0]),
        (document.getElementById("maxCost").value = value[1])
      )
    );
  };
  const [ratingvalues, setRatingvalues] = useState([]);
  /*
  on change rating checkbox method
  */
  const onChangeRating = (value) => {
    setProductList(products.filter((product) => product.rating >= value));

    var modifiedRating = [...ratingvalues];
    modifiedRating.push(value);
    setRatingvalues(modifiedRating);
  };

  const onUncheckMark = (value) => {
    var modifiedRating = [...ratingvalues];
    const modifiedData = (modifiedRating || []).filter((x) => x !== value);
    /*
    find min values
    */
    var filteredProducts = products;
    if (modifiedData && modifiedData.length && value !== 1) {
      var minValue = Math.min(...modifiedData);
      if (minValue && minValue !== Infinity) {
        filteredProducts = products.filter(
          (product) => product.rating >= minValue
        );
        setRatingvalues(modifiedData);
      }
    } else {
      filteredProducts = products;
    }
    setProductList(filteredProducts);
  };

  //delete order
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const onClickDelete = (product) => {
    setProductSelected(product);
    setDeleteModal(true);
  };

  const onClickView = (product) => {
    const data = {
      pro_id: product.pro_id,
    };
    dispatch(onGetProductById(data));
    setDetailsModal(true);
  };

  const handleDeleteProduct = () => {
    if (productSelected) {
      dispatch(deleteProducts(productSelected.pro_id));
      setDeleteModal(false);
    }
  };

  // Displat Delete Button
  const [dele, setDele] = useState(0);
  const displayDelete = () => {
    const ele = document.querySelectorAll(".productCheckBox:checked");
    const del = document.getElementById("selection-element");
    setDele(ele.length);
    if (ele.length === 0) {
      del.style.display = "none";
    } else {
      del.style.display = "block";
    }
  };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".productCheckBox:checked");
    const del = document.getElementById("selection-element");
    ele.forEach((element) => {
      dispatch(deleteProducts(element.value));
      setTimeout(() => {
        toast.clearWaitingQueue();
      }, 3000);
      del.style.display = "none";
    });
  };

  /*
  {
        header: "#",
        accessorKey: "pro_id",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell) => {
          return (
            <input
              type="checkbox"
              className="productCheckBox form-check-input"
              value={cell.getValue()}
              onClick={() => displayDelete()}
            />
          );
        },
      },
       {
        header: "Published",
        accessorKey: "pro_dateAdded",
        enableColumnFilter: false,
        cell: (cell) => {
          return <Published {...cell} />;
        },
      },
      */
  const columns = useMemo(
    () => [
      {
        header: "Product",
        accessorKey: "pro_name",
        enableColumnFilter: false,
        cell: (cell) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-shrink-0 me-3">
                <div className="avatar-sm bg-light rounded p-1">
                  <img
                    src={
                      cell.row.original.pro_imageURLs
                        ? cell.row.original.pro_imageURLs.split(",")[0]
                        : imageEmpty
                    }
                    alt="product-image"
                    style={{
                      width: "50px",
                      height: "50px",
                      objectFit: "contain",
                    }}
                    className="img-fluid d-block"
                  />
                </div>
              </div>
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1">{cell.getValue()}</h5>
                <p className="text-muted mb-0">
                  Category :{" "}
                  <span className="fw-medium">
                    {" "}
                    {cell.row.original.pro_categoryName}
                  </span>
                </p>
                {cell.row.original.pro_packQuantity > 1 && (
                  <span className="badge rounded-pill bg-primary text-dark">
                    pack of {cell.row.original.pro_packQuantity}
                  </span>
                )}
                <div className="d-flex align-items-center gap-2">
                  {cell.row.original.pro_MAP != null &&
                    cell.row.original.pro_MAP != "0" && (
                      <div className="tooltip-icon">
                        <i className="ri-price-tag-3-line me-1 text-danger" />
                        <span className="tooltip-text  text-danger">
                          MAP Pricing:{" "}
                          <span className="fw-semibold">
                            {new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                            }).format(cell.row.original.pro_MAP)}
                          </span>
                        </span>
                      </div>
                    )}
                  {cell.row.original.pro_extendedLeadTime &&
                    cell.row.original.pro_extendedLeadTime != 0 && (
                      <div className="tooltip-icon">
                        <i className="ri-time-line me-1 text-danger" />
                        <span className="tooltip-text text-danger">
                          Extended Lead Time:{" "}
                          <span className="fw-semibold">
                            {cell.row.original.pro_extendedLeadTime}{" "}
                            {cell.row.original.pro_extendedLeadTime.indexOf(
                              "days"
                            ) < 0
                              ? "days"
                              : ""}
                          </span>
                        </span>
                      </div>
                    )}
                </div>
              </div>
            </div>
          </>
        ),
      },
      {
        header: "Supplier",
        accessorKey: "pro_supplierName",
        enableColumnFilter: false,
      },
      {
        header: "Product Codes",
        accessorKey: "pro_UPCCode",
        enableColumnFilter: false,
        cell: (cell) => {
          return (
            <span>
              {cell.getValue() ? cell.getValue() : "No UPC Code"}
              {cell.row.original.pro_ASIN && (
                <span> / {cell.row.original.pro_ASIN}</span>
              )}
            </span>
          );
        },
      },
      {
        header: "Sales Channel",
        accessorKey: "pro_salesChannel",
        enableColumnFilter: false,
        width: "15px",
        cell: (cell) => {
          const salesChannel = cell.getValue();
          return <SalesChannels channel={salesChannel} />;
        },
      },
      {
        header: "Restricted Channel(s)",
        accessorKey: "pro_restrictedChannels",
        enableColumnFilter: false,
        cell: (cell) => {
          const salesChannel = cell.getValue();
          return <RestrictedChannels channel={salesChannel} />;
        },
      },
      {
        header: "Status",
        accessorKey: "pro_status",
        enableColumnFilter: false,
        cell: (cell) => {
          return (
            <span
              style={{ width: "80px" }}
              className={
                cell.getValue() == 0
                  ? "badge text-dark rounded-pill bg-success"
                  : "badge text-dark rounded-pill bg-danger"
              }
            >
              {cell.getValue() === 0 ? "Active" : "Inactive"}
            </span>
          );
        },
      },
      {
        header: "Stock",
        accessorKey: "pro_inStock",
        enableColumnFilter: false,
        cell: (cell) => {
          return (
            <span
              style={{ width: "80px" }}
              className={
                cell.getValue()
                  ? "badge text-dark rounded-pill bg-success"
                  : "badge text-dark rounded-pill bg-danger"
              }
            >
              {cell.getValue() ? "In Stock" : "Out of Stock"}
            </span>
          );
        },
      },

      {
        header: "Price",
        accessorKey: "pro_price",
        enableColumnFilter: false,
        cell: (cell) => {
          return (
            <span>
              {cell.getValue().toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
              })}
            </span>
          );
        },
      },
      {
        header: "last Updated",
        accessorKey: "pro_lastModifiedDate",
        enableColumnFilter: false,
        cell: (cell) => (
          <>
            {moment(cell.getValue()).format("MM/DD/YYYY")}
            <br />
            <small className="text-muted">
              {"     "}
              {moment(cell.getValue()).format("hh:mm A")}
            </small>
          </>
        ),
      },
      /*
      {
        header: "Action",
        cell: (cell) => {
          return (
            <UncontrolledDropdown>
              <DropdownToggle
                href="#"
                className="btn btn-soft-secondary btn-sm"
                tag="button"
              >
                <i className="ri-more-fill" />
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-end">
                <DropdownItem
                  onClick={() => {
                    const productData = cell.row.original;
                    onClickView(productData);
                  }}
                >
                  <i className="ri-eye-fill align-bottom me-2 text-muted"></i>{" "}
                  View
                </DropdownItem>

                <DropdownItem
                  href="apps-ecommerce-add-product"
                  onClick={() => {
                    const productData = cell.row.original;
                    onClickDelete(productData);
                  }}
                >
                  <i className="ri-pencil-fill align-bottom me-2 text-muted"></i>{" "}
                  Edit
                </DropdownItem>

                <DropdownItem divider />
                <DropdownItem
                  href="#"
                  onClick={() => {
                    const productData = cell.row.original;
                    onClickDelete(productData);
                  }}
                >
                  <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i>{" "}
                  Delete
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          );
        },
      },*/
    ],
    []
  );

  document.title = "Products | Buyers Club";

  return (
    <div className="page-content">
      <ProductDetail
        product={product}
        show={detailsModal}
        onClose={setDetailsModal}
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteProduct}
        onCloseClick={() => setDeleteModal(false)}
      />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Product Catalog" pageTitle="Products" />
        <Row>
          <div className="col-xl-12">
            <div>
              <div className="card">
                <div className="card-header border-0">
                  <div className="row align-items-center">
                    <div className="col">
                      <Nav
                        className="nav-tabs-custom card-header-tabs border-bottom-0"
                        role="tablist"
                      >
                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "1" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("1", "All");
                            }}
                            href="#"
                          >
                            All{" "}
                            <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                              {pagination.total}
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "6" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("6", "HotList");
                            }}
                            href="#"
                          >
                            Hot List
                            <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                              {paginationHot.totalItems}
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "2" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("2", "Active");
                            }}
                            href="#"
                          >
                            Active
                            <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                              {pagination.totalActive}
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "3" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("3", "Inactive");
                            }}
                            href="#"
                          >
                            Inactive
                            <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                              {pagination.totalInactive}
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "4" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("4", "In Stock");
                            }}
                            href="#"
                          >
                            In Stock
                            <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                              {pagination.totalInStock}
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "5" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("5", "Out of Stock");
                            }}
                            href="#"
                          >
                            Out of Stock
                            <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                              {pagination.totalOutOfStock}
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "7" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("7", "Hidden");
                            }}
                            href="#"
                          >
                            Hidden
                            <span className="badge bg-danger-subtle text-danger align-middle rounded-pill ms-1">
                              {pagination.totalNotVisible || 0}
                            </span>
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </div>
                  </div>
                </div>
                <CardBody className="border border-dashed border-end-0 border-start-0">
                  <form>
                    <Row>
                      <Col sm={5}>
                        <div className="search-box me-2 mb-2 d-inline-block">
                          <DebouncedInput
                            value={searchText ?? ""}
                            onChange={(value) => setSearchText(value)}
                            placeholder="Search products"
                          />
                          <i className="bx bx-search-alt search-icon"></i>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
                <div className="card-body pt-0">
                  {loading || isLoading ? (
                    <Loader />
                  ) : productList && productList.length > 0 ? (
                    <TableContainer
                      columns={columns}
                      data={productList || []}
                      isGlobalFilter={true}
                      isAddUserList={false}
                      customPageSize={10}
                      divClass="table-responsive mb-1"
                      tableClass="mb-0 align-middle table-borderless"
                      theadClass="table-light text-dark text-uppercase"
                      isProductsFilter={true}
                      SearchPlaceholder="Search Products..."
                      pagination={activeTab != "6" ? pagination : paginationHot}
                      manualPagination={true}
                      onPreviousPage={() => {
                        getProducts(pagination.currentPage - 1);
                      }}
                      onNextPage={() => {
                        getProducts(pagination.currentPage + 1);
                      }}
                      onGetPage={(page, pageSize) => {
                        getProducts(page, pageSize);
                      }}
                      onRowClick={(row) => {
                        const productData = row.original;
                        onClickView(productData);
                      }}
                    />
                  ) : (
                    <div className="py-4 text-center">
                      <div>
                        <lord-icon
                          src="https://cdn.lordicon.com/msoeawqm.json"
                          trigger="loop"
                          colors="primary:#405189,secondary:#0ab39c"
                          style={{ width: "72px", height: "72px" }}
                        ></lord-icon>
                      </div>

                      <div className="mt-4">
                        <h5>Sorry! No Products Found</h5>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Row>
      </Container>
    </div>
  );
};

export default Products;
